<template>

  <div>   


      <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{'is-active':showModal}">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card is-info">
          
            <header class="modal-card-head is-info">
              <p class="modal-card-title">Join Xmarine for FREE</p>
              <button class="delete" aria-label="close" @click="close"></button>
            </header>
            <section class="modal-card-body">  

              <form v-if="!signUpClicked" autocomplete="off">
                <div class="form-group-reg">    
                  <input class="input half" type="text" placeholder="First name" v-model="firstname" required>
                  <input class="input half" type="text" placeholder="Last name" v-model="lastname" required>
                </div>

                <div class="form-group-reg">      
                  <input class="input" type="email" placeholder="Email address" v-model="useremail" required>
                </div>

                <div class="form-group-reg">      
                  <input class="input" autocomplete="off" type="tel" maxlength="10" placeholder="Mobile number 04.." v-on:keypress="isNumber($event)" v-model="userphone" required>
                </div>

                <div class="form-group-reg">      
                  <input class="input" autocomplete="off" type="password" v-model="userpassword" placeholder="Password at least 6 characters" required>
                </div>

                <div class="small-text has-text-centered">By joining Xmarine you agree to our <span @click="readTerms()" class="simple-link">Terms of Use</span>
                </div>
              </form>

              <div v-if="signUpClicked" class="signed-up">
                <h3>Signing you up. Please wait...</h3>
                <!-- <p><font-awesome-icon icon="sync-alt" class="fa-spin" /> &nbsp;</p> -->
                <div v-if="errorMsg != ''" class="error-message">{{errorMsg}}</div>
                <div class="spacer s30"></div>
              </div>

            </section>
            <footer class="modal-card-foot centered">
              <button :disabled="!showSignupButton || signUpClicked" class="button is-info is-medium" @click="newSignUp()"><font-awesome-icon icon="thumbs-up" />&nbsp; Sign Up Now</button>
              <button class="button is-medium" @click="close">Cancel</button>
            </footer>        

        </div>
      </div>            

            
      


  </div>

</template>



<script>

import firebase from 'firebase/app';
import { db } from '@/main.js';
import NProgress from 'nprogress';

export default {

  components: {

  },

  props: {

  },

  mounted() {
    
  },

  computed: {
    emailIsValid() {
      return this.reg.test(this.useremail);
    },
    phoneNumberValid() {
      return this.userphone.length == 10 && this.userphone.slice(0,2) == '04';
    },
    hasFullName() {
      return this.firstname != '' && this.lastname != '';
    },
    passwordValid() {
      return this.userpassword.length > 5;
    },
    finalNumber() {
      return "+61" + this.userphone.slice(1,10);
    },
    showSignupButton() {
      return this.phoneNumberValid && this.hasFullName && this.passwordValid && this.emailIsValid;
    },
    fullName() {
      return this.capitalise(this.firstname.trim() )+ ' ' + this.capitalise(this.lastname.trim());
    },
    trimmedEmail() {
      return this.useremail.trim();
    }

  },

  data: function() {
    return {
      showModal: true,
      firstname: '',
      lastname: '',
      useremail: '',
      userphone: '',
      userpassword: '',
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      signUpClicked: false,
      errorMsg: '',

    }
  },

  methods: {

    close: function() {
      this.showModal = false;
      let result = {
        answer: 'Signup cancelled',
      };
      this.$emit('signupCancelled', result);
    },

    isNumber: function($evt) {
      $evt = ($evt) ? $evt : window.event;
      var charCode = ($evt.which) ? $evt.which : $evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        $evt.preventDefault();
      } else {
        return true;
      }
    },

    capitalise(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    newSignUp: function() {

      NProgress.start();
      let self = this;
      this.signUpClicked = true;

      var createNewUserAtSignup = firebase.functions().httpsCallable('createNewUserAtSignup');
      createNewUserAtSignup({
        userFirstName: self.firstname,
        userLastName: self.lastname,
        userFullName: self.fullName,
        userEmail: self.trimmedEmail,
        userPhone: self.userphone,
        userPassword: self.userpassword,
        finalNumber: self.finalNumber,
        signupPlatform: 'web',
      })
      .then(function(result) {
        //let sanitizedMessage = result.data.text;
        if (result.data.message == 'Success') {
          console.log('User created successfully with ID ',result.data.newuserid);
          self.signInByEmail(result.data.newuserid);          
        } else {
           console.log('Error creating user: ',result.data.text);
           self.errorMsg = error.text.errorInfo.message;
          // do something on user creation error:
        }
        //console.log(result.data);
        NProgress.done();
      })
      .catch(function(error) {
        console.log('Error: ',error);
        console.log('Text Error: ',error.text);
        self.errorMsg = 'There was an error creating your account. Please refresh the page and try again.';
        //console.log(error.code,error.message,error.details);
        NProgress.done();
      });  

    },

    signInByEmail() {
      NProgress.start();
      var self = this;
      let result = {};
      firebase.auth().signInWithEmailAndPassword(self.trimmedEmail, self.userpassword).then( user => {
          // self.$router.replace('my-dashboard');
          this.$emit('signupSuccess', result);
          NProgress.done();
        },
        error => {
          NProgress.done();
          alert('We couldn\'t sign you in. Please refresh the page and try to log in again.')
        }
      );
    },

    readTerms: function() {
      this.$emit('readTerms');
    },







  }


}

</script> 

<style lang="scss" scoped>

  .fa-spin {
    animation-duration: 0.8s; // or something else
  }
  h3 {
    font-size: 1.3rem;
    font-weight: bold;
    color: #0a86e0;
  }
  .spinner {
    svg {
      font-size: 2rem;
      font-weight: bold;
      color: #0a86e0;
      margin-top: 1rem;
    }
  }
  .form-group-reg {
    text-align: left;
    margin-bottom: 0;
    .input {
      &.half {
        width: 47.5%;
        margin-right: 5%;
        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }
  .signed-up {
    color: dodgerblue;
    h3 {
      margin: 1rem 0;
    }
  }
  .error-message {
    color: red;
    font-weight: bold;
    margin: 1rem 0;
  }

</style>









